import React from 'react';

const DataDeletionPage = () => {
  return (
    <div className="bg-white max-w-4xl mx-auto p-8 shadow-sm">
      <h1 className="text-2xl font-bold mb-6">Suppression des données</h1>

      <p className="mb-6 text-gray-700">
        Cette page décrit comment les utilisateurs peuvent demander la suppression des données personnelles
        associées à leur compte Elille Academy, conformément aux exigences des plateformes (dont Meta / Facebook)
        pour les applications qui accèdent à des informations utilisateur.
      </p>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">1. Données concernées</h2>
        <p className="mb-3 text-gray-700">
          Sur demande, nous pouvons supprimer ou anonymiser les informations liées à votre compte sur notre
          plateforme, notamment : identité de profil, adresse e-mail, historique d&apos;inscription aux formations,
          progression pédagogique et toute autre donnée que vous nous avez fournie directement via le site.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">2. Comment demander la suppression</h2>
        <p className="mb-3 text-gray-700">
          Envoyez un e-mail à{' '}
          <a href="mailto:support@elilleacademy.com" className="text-elille-blue underline">
            support@elilleacademy.com
          </a>{' '}
          depuis l&apos;adresse e-mail associée à votre compte, avec l&apos;objet « Demande de suppression des
          données ». Indiquez votre nom complet et, si possible, l&apos;adresse e-mail utilisée pour vous inscrire sur
          Elille Academy.
        </p>
        <p className="text-gray-700">
          Vous pouvez également utiliser notre{' '}
          <a href="/contact" className="text-elille-blue underline">
            formulaire de contact
          </a>{' '}
          en précisant qu&apos;il s&apos;agit d&apos;une demande de suppression de compte et de données.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">3. Délai de traitement</h2>
        <p className="mb-3 text-gray-700">
          Nous accusons réception de votre demande dans les meilleurs délais et traitons la suppression dans un
          délai raisonnable, sauf obligation légale de conservation de certaines informations (par exemple traces
          comptables ou litiges en cours).
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">4. Données détenues par des tiers</h2>
        <p className="mb-3 text-gray-700">
          Si vous vous êtes connecté via un fournisseur tiers (par exemple Facebook / Google), vous pouvez aussi
          révoquer l&apos;accès de l&apos;application depuis les paramètres de votre compte chez ce fournisseur. La
          suppression sur Elille Academy reste nécessaire pour effacer les données stockées sur nos serveurs.
        </p>
      </section>

      <section className="mb-4">
        <h2 className="text-xl font-semibold mb-3">5. Nous contacter</h2>
        <p className="text-gray-700">
          Pour toute question sur cette procédure :{' '}
          <a href="mailto:support@elilleacademy.com" className="text-elille-blue underline">
            support@elilleacademy.com
          </a>
          .
        </p>
      </section>

      <div className="mt-8 pt-6 border-t border-gray-200">
        <p className="text-sm text-gray-500 text-center">
          Dernière mise à jour : 23 avril 2026
        </p>
      </div>
    </div>
  );
};

export default DataDeletionPage;
